
    import Component from "vue-class-component";
    import Vue from "vue";
    import {Prop} from "vue-property-decorator";
    import {ApplicationActions, ApplicationState, ApplicationViewModel} from "@/api-client";
    import ApplicationStateBadge from "@/features/applications/components/ApplicationStateBadge.vue";
    import translateApplicationType from "@/features/applications/components/ApplicationTypeTranslator";

    
    @Component({
        components: {
            ApplicationStateBadge
        },
        methods: {
            translateApplicationType
        }
    })
    export default class ApplicationDetails extends Vue {
        @Prop({required: true})
        application!: ApplicationViewModel;

        @Prop({required: true})
        actions!: ApplicationActions;

        get showSubmittedDate(): boolean {
            const allow = this.application.state === ApplicationState.ApplicationNotSubmitted || 
                          this.application.state === ApplicationState.ApplicationRejected;
            return !allow;
        }
    }
